import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import React from 'react';
import { COLOR } from '../../styles/colors';
import Icon from '../Icon/Icon';
import {
  StyledCheckboxLabel,
  StyledHiddenCheckbox,
  StyledVisibleCheckbox
} from './StyledCheckbox';

interface ICheckboxProps extends React.HTMLProps<HTMLInputElement> {
  partiallyChecked?: boolean;
  parentHandlesLabel?: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = ({
  checked = false,
  partiallyChecked = false,
  size = 20,
  disabled = false,
  parentHandlesLabel = false,
  ...rest
}) => (
  <StyledCheckboxLabel as={parentHandlesLabel ? 'span' : undefined}>
    <StyledHiddenCheckbox
      value={`${checked}`}
      checked={checked}
      disabled={disabled}
      {...(rest as any)} // coulnd't figure this out as Partial<React.HTMLProps<HTMLInputElement>>)
    />

    <StyledVisibleCheckbox
      $size={size}
      $isDisabled={disabled}
      $isChecked={checked || partiallyChecked}
    >
      {(checked || partiallyChecked) && (
        <Icon
          icon={partiallyChecked ? faMinus : faCheck}
          size={12}
          color={COLOR.white}
        />
      )}
    </StyledVisibleCheckbox>
  </StyledCheckboxLabel>
);

export default Checkbox;
